import { Lock, KeyRound, Anchor } from "lucide-react";

const UPCOMING = [
  { vol: "Vol 1", title: "The Engine Room", status: "Drafting" },
  { vol: "Vol 2", title: "Reserves & Reinvest", status: "Outlined" },
  { vol: "Vol 3", title: "The Operator's Year", status: "Concept" },
];

export default function AuthenticatedVault() {
  return (
    <section id="authenticated-vault" data-testid="authenticated-vault">
      <div className="mb-7">
        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-violet animate-pulse-violet" />
          <span className="font-mono text-[10px] tracking-[0.32em] uppercase text-violet-soft">
            Authenticated Vault · Vol 1+
          </span>
        </div>
        <h2 className="mt-3 font-heading text-3xl sm:text-4xl text-white tracking-tight">
          The Sealed Archives · <span className="gold-text">Sovereign Login</span>
        </h2>
        <p className="mt-3 max-w-2xl text-white/55 leading-relaxed">
          Subsequent volumes are released behind sovereign authentication via
          <span className="text-violet-soft"> EIGOOINC.NET SSO</span>. Members
          of the Armada with verified credentials access the full archive.
        </p>
      </div>

      <div className="relative rounded-2xl border border-white/8 bg-[#080808] p-7 sm:p-9 overflow-hidden">
        <div className="absolute -right-32 -top-32 w-72 h-72 rounded-full bg-violet/10 blur-3xl" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 relative">
          {/* Auth callout */}
          <div className="lg:col-span-5 flex flex-col">
            <div className="flex items-center gap-2 mb-3">
              <KeyRound className="w-3.5 h-3.5 text-gold" />
              <span className="font-mono text-[10px] tracking-[0.26em] uppercase text-gold/90">
                SSO Provider · EIGOOINC.NET
              </span>
            </div>
            <h3 className="font-heading text-2xl text-white leading-tight">
              Sovereign Identity Required
            </h3>
            <p className="mt-3 text-white/55 leading-relaxed">
              Vol 1 and beyond are reserved for credentialed operators. The
              authentication layer is being provisioned. When live, you&apos;ll sign
              in once and the archive opens for life.
            </p>

            <button
              data-testid="sso-coming-soon-btn"
              disabled
              className="mt-5 inline-flex items-center gap-2 h-11 px-6 rounded-full bg-black/60 border border-violet/30 text-violet-soft font-mono text-[11px] tracking-[0.22em] uppercase cursor-not-allowed opacity-90 hover:opacity-100 transition-opacity self-start"
            >
              <Lock className="w-4 h-4" /> Sign in with EIGOOINC · Soon
            </button>

            <div className="mt-5 flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase text-white/40">
              <Anchor className="w-3 h-3 text-gold/70" />
              Provisioning · SSO · TLS · Vault Mesh
            </div>
          </div>

          {/* Roadmap */}
          <div className="lg:col-span-7">
            <div className="font-mono text-[10px] tracking-[0.26em] uppercase text-white/50 mb-3">
              Forthcoming Volumes
            </div>
            <div className="space-y-3">
              {UPCOMING.map((u, i) => (
                <div
                  key={u.vol}
                  data-testid={`upcoming-vol-${i + 1}`}
                  className="group flex items-center justify-between p-4 rounded-md border border-white/8 bg-black/50 hover:border-gold/30 transition-colors"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 grid place-items-center rounded-md border border-gold/30 bg-black">
                      <Lock className="w-4 h-4 text-gold/80" />
                    </div>
                    <div>
                      <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-gold/85">
                        {u.vol}
                      </div>
                      <div className="font-heading text-lg text-white leading-tight mt-0.5">
                        {u.title}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono text-[9px] tracking-[0.24em] uppercase text-white/40">
                      Status
                    </div>
                    <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-violet-soft mt-0.5">
                      {u.status}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
